/**
 * Mixin for June analitics to simlify usage from different components.
 */

export default {
  methods: {
    juneTrack(event, payload) {
      if (window.analytics && window.analytics.track) {
        window.analytics.track(event, payload);
      }
    },
  },
};
